import { render, staticRenderFns } from "./AccountOptionListItem.vue?vue&type=template&id=0b4d88ee"
import script from "./AccountOptionListItem.vue?vue&type=script&lang=js"
export * from "./AccountOptionListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports